/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useState } from "react";
import Fade from "@material-ui/core/Grow";
import LazyLoad from "react-lazyload";
import Link from "@material-ui/core/Link";

import { SIZES } from "../../constants";

const imageWrappperWidth =
  window.innerWidth < 480 ? window.innerWidth / 2 - 14 : SIZES.leftBarOpened / 2 - 47;

const ImageWrapper = styled.div`
  width: ${imageWrappperWidth}px;
  position: relative;
  background-color: #444;
  &:hover {
    outline: 1px solid #cdcc32;
  }
  &:hover .author {
    opacity: 0.9;
  }
`;

const Author = styled.div`
  position: absolute;
  bottom: 2px;
  right: 2px;
  transition: all 0.2s ease-in-out;
  opacity: 0;
  line-height: 1;
  background: #00000066;
  font-size: 13px;
  padding: 4px;
  > a {
    color: white;
  }
`;

const Image = props => {
  const { image, onClick } = props;
  const [isLoading, setIsLoading] = useState(true);

  const k = imageWrappperWidth / image.size.w;

  const handleDragStart = e => {
    e.dataTransfer.setData("text/plain", JSON.stringify(image));
  };

  return (
    <ImageWrapper key={image.id}>
      <LazyLoad height={image.size.h * k}>
        <Fade in={!isLoading}>
          <div>
            <img
              onDragStart={handleDragStart}
              onClick={() => onClick(image)}
              css={css`
                width: 100%;
                cursor: pointer;
                height: ${image.size.h * k}px;
                object-fit: cover;
              `}
              src={image.thumb}
              onLoad={e => setIsLoading(false)}
              alt={image.meta.author.name}
            />
            <Author className="author">
              <Link
                href={image.meta.author.url}
                target="_blank"
                color="secondary"
                rel="nofollow"
              >
                {image.meta.author.name}
              </Link>
            </Author>
          </div>
        </Fade>
      </LazyLoad>
    </ImageWrapper>
  );
};

export default Image;
